import { z } from 'zod'
import { optionalString, requiredString, timestampedDocSchema } from '../utils/basicSchemas/document.z.schema'
import { mongoId, mongoIdSchema } from '../utils/basicSchemas/_id.z.schema'
import { ZSchema } from '../utils/zodSchema'


const onboardingTasksIdSchema = z.object({
    id: mongoId("onboardingTasks id"),
})

const onboardingTasksIDValidator = new ZSchema(
    { paramSchema: onboardingTasksIdSchema })


// TODO: UNTESTED:
export { onboardingTasksIDValidator }
